import { Headline, Headline2 } from "@volumental/common";
import type { JSX } from "react";
import { useTranslation } from "react-i18next";
import { cn } from "../../../lib/cn";

interface PDetailsProps {
  imageSrc?: string;
  displayName: string;
  title: string;
  mode: "recommendation" | "sizeguide";
}
export function ProductDetails({ imageSrc, displayName, mode, title }: PDetailsProps): JSX.Element {
  const { t } = useTranslation();

  return (
    <div className="flex flex-row py-6 justify-between">
      <div className="flex flex-col justify-start text-left">
        <Headline
          className={cn(
            "font-normal overflow-hidden leading-normal my-auto",
            mode === "recommendation" ? "text-base" : "text-3xl"
          )}
        >
          {title}
        </Headline>
        <Headline2
          className={cn(
            "overflow-hidden leading-normal m-0",
            mode === "recommendation" ? "font-bold text-xl" : "font-normal text-sm"
          )}
        >
          {displayName}
        </Headline2>
      </div>
      {imageSrc && (
        <img
          src={imageSrc}
          role="presentation"
          alt={t("imageAlt.productImage")}
          className="max-w-14 max-h-14 shrink rounded-lg border border-black/10 bg-white"
        />
      )}
    </div>
  );
}
